exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".zoom-on-hover{position:relative;overflow:hidden}.zoom-on-hover .normal{max-width:100%}.zoom-on-hover .zoom{position:absolute;opacity:0;transform-origin:top left}.zoom-on-hover.zoomed .zoom{opacity:1}.zoom-on-hover.zoomed .normal{opacity:0}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader!./src/Assets/utilities/zoom/zoomOnHover.css
// module id = 2542
// module chunks = 1